// libs
import React from "react";
import Icon from "@ant-design/icons";

const StatisticsSvg = () => (
  <svg
    width="1.8em"
    height="1.8em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 26H4V6"
      stroke="#4867AA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 8L16 18L12 14L4 22"
      stroke="#4867AA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 13V8H21"
      stroke="#4867AA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StatisticsIcon = (props) => <Icon component={StatisticsSvg} {...props} />;

export default StatisticsIcon;
